// extracted by mini-css-extract-plugin
export default {"search":"Searchbar_search__RgdH8"};